/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';
import { pd } from '@airasia-phoenix/react-native/utils';

export const styles = StyleSheet.create((pd) => ({
  container: {
    flex: 1,
  },
  section: {
    position: 'relative',
  },
  sectionSpacing: {
    marginBottom: {
      xs: pd.ref.space.spacing10.px,
      md: pd.ref.space.spacing40.px,
    },
  },
  title: {
    marginBottom: {
      xs: pd.ref.space.spacing10.px,
      md: 6,
    },
  },
  mobileCarouselInset: {
    marginHorizontal: -pd.ref.space.spacing20.px,
  },
  desktopCarouselWrapper: {
    position: 'relative',
    width: '100%',
  },
  desktopCarouselInset: {
    overflow: 'hidden',
  },
  /** Row height follows tallest card (multi-line title/subtitle); no fixed height. */
  desktopCarouselList: {
    flexGrow: 0,
  },
  desktopCardContainer: {
    alignItems: 'stretch',
  },
  desktopArticleCardPressable: {
    alignItems: 'flex-start',
    padding: pd.ref.space.spacing10.px,
  },
  desktopCardSpacingLeft: {
    marginLeft: pd.ref.space.spacing20.px,
  },
  desktopCardSpacingRight: {
    marginRight: pd.ref.space.spacing20.px,
  },
  desktopChevron: {
    position: 'absolute',
    width: 32,
    height: 32,
    backgroundColor: pd.sys.colour.bg_primary.toString(),
    borderRadius: 22,
    borderWidth: 1,
    borderColor: pd.sys.colour.outline_low.toString(),
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
  },
  desktopChevronLeft: { left: -pd.ref.space.spacing40.px },
  desktopChevronRight: { right: -pd.ref.space.spacing40.px },
}));

export default styles;
